export {AccountManagementModule} from "./core/account-management.module";
export {AccountManagementProviderService} from "./core/account-management-provider.service";